/**
 * Facilitate scaling popup modal.
 */
const modalGallery = document.querySelectorAll('.scale-modal-gallery');
if (modalGallery.length) {
	const setPos = (item, modal) => {
		const rect = item.getBoundingClientRect();
		modal.style.setProperty('--h', `${rect.height}px`);
		modal.style.setProperty('--w', `${rect.width}px`);
		modal.style.setProperty('--x', `${rect.left}px`);
		modal.style.setProperty('--y', `${rect.top}px`);
		const styles = getComputedStyle(item);
		modal.style.setProperty('--paz-x', styles.getPropertyValue('--paz-x'));
		modal.style.setProperty('--paz-y', styles.getPropertyValue('--paz-y'));
		modal.style.setProperty('--paz-z', styles.getPropertyValue('--paz-z'));
		const pad = 48; // 24px * 2
		const maxH = document.body.clientHeight - pad;
		let w = document.body.clientWidth - pad;
		let h = w * 0.5625;
		if (h > maxH) {
			do {
				h -= 1;
			} while (h > maxH && h >= 375);
			w = h * 1.7777777777778;
		}
		modal.style.setProperty('--w-frame', `${w}px`);
		modal.style.setProperty('--h-frame', `${h}px`);
		const color = item.style.getPropertyValue('--c');
		modal.style.setProperty('--c', color);
	};
	modalGallery.forEach((scaleModal) => {
		const wrap = scaleModal.nextElementSibling;
		const modal = wrap.firstElementChild;
		scaleModal.addEventListener('click', (e) => {
			if (e.target.classList.contains('scale-modal-item')) {
				const item = e.target;
				const img = modal.lastElementChild;
				const iframe = modal.firstElementChild.nextElementSibling;
				img.src = '//:0';
				img.src = item.nextElementSibling.currentSrc;
				const show = () => {
					iframe.src = item.dataset.iframeSrc;
					modal.classList.add('morphing');
					modal.classList.add('active');
					setPos(item, modal);
					document.body.classList.add('modal-active');
					document.body.classList.add('modal-ani-active');
					if (img.complete) {
						modal.classList.remove('morphing');
					} else {
						img.addEventListener(
							'load',
							() => modal.classList.remove('morphing'),
							{ once: true }
						);
					}
				};
				// if/once the image has loaded then show the popup (to avoid an image flicker)
				if (img.complete) {
					show();
				} else {
					img.addEventListener('load', show);
				}
			}
		});
		wrap.addEventListener('click', (e) => {
			modal.classList.remove('active');
			document.body.classList.remove('modal-ani-active');
			setTimeout(() => {
				document.body.classList.remove('modal-active');
			}, 1500);
		});
	});
	// hack to get animations working on first click (otherwise close button blinks in first time)
	document.body.classList.add('modal-ani-active');
	setTimeout(() => {
		document.body.classList.remove('modal-ani-active');
	}, 10);
}
